import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  Button,
  Box,
  Dialog,
  Grid,
  Container,
  LinearProgress,
  ButtonGroup,
} from "@mui/material";
//import Filter from 'src/components/common/Filter';
import AMFilter from "src/pages/components/AMFilter";
//import { getReportControls } from 'src/services/commonService';
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { preLoadFormDetails } from "src/services/generalService";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet-async";

import http from "src/services/httpService";
import StReportViewer from "./StReportViewer";

function ReportViewer({
  menuItemCode,
  autoRun,
  onCloseViewer,
  autoRunReportId,
  ...rest
}) {
  let { id: reportId } = useParams();
  reportId = autoRunReportId || reportId;
  const [reportTitle, setReportTitle] = useState("");
  const [reportToolTip, setReportToolTip] = useState("");

  const [filterControls, setFilterControls] = useState([]);
  const [filterCriteria, setFilterCriteria] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [viewPDF, setViewPDF] = useState(autoRun || false);
  const [reportPath, setReportPath] = useState("");
  const [reportDataSet, setReportDataSet] = useState();
  const [stReportViewerKey, setStReportViewerKey] = useState(1);
  // #region Events
  // let { id: urlId } = useParams();

  useEffect(() => {
    if (autoRun) {
      handleOnClickPreview(rest.filterCriteria);
    } else {
      setIsLoading(true);
      (async () => {
        const { data } = await preLoadFormDetails(menuItemCode, reportId);
        const controls = data.formControls;
        if (controls && controls.length) {
          const savedCriteria = localStorage.getItem(`reportFilter_${reportId}`);
          let defaultCriteriaData = {};
          if (savedCriteria) {
            defaultCriteriaData = JSON.parse(savedCriteria);
          }

          /*محتاجينها ولا لأ هانبقى نشوف لان الformcontrols بيكون معاها الـ defaultevalues وممكن كمان نجيبها من الـ ReportCriteria
        controls.forEach((element) => {
          if (element.defaultValue) {
            let isJson = false;
            try {
              JSON.parse(element.defaultValue);
              isJson = true;
            } catch (e) {}

            if (isJson) {
              defaultCriteriaData[element.controlName] = JSON.parse(
                element.defaultValue
              );
            } else {
              defaultCriteriaData[element.controlName] = element.defaultValue;
            }
          }
        });
        */
          setFilterControls(controls);
          console.log("defaultCriteriaData", defaultCriteriaData);
      
          setFilterCriteria(defaultCriteriaData);
        } else {
          setFilterControls([]);
          setFilterCriteria({});
        }
        setReportTitle(data.pageTitle);
        setReportToolTip(data.pageToolTip);
        setIsLoading(false);
      })();
    }
  }, [menuItemCode, rest.filterCriteria, reportId]);

  const handleOnClickPreview = (filterCriteria) => {
    setIsLoading(true);
    const requestBody = {
      ReportId: reportId,
      Parameters: filterCriteria,
    };

    http.axiosInstance
      .request({
        url: `${http.getApiURL()}/Reports/GetReportData`,
        method: "post",
        headers: {
          ReportId: reportId,
          MenuItemCode: menuItemCode,
        },
        data: { dataObj: JSON.stringify(requestBody) },
      })
      .then((response) => {
        setReportPath(response.data.path);
        setReportDataSet(JSON.parse(response.data.dataSet));
        setViewPDF(true);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        toast.error(error.message);
      });
  };

  const handleApplyFilter = (filterCriteria) => {
    const validControlNames = filterControls.map(control => control.fieldName);
    const filteredCriteria = Object.keys(filterCriteria).reduce((acc, key) => {
      if (validControlNames.includes(key)) {
        acc[key] = filterCriteria[key];
      }
      return acc;
    }, {});
    
    const filteredCriteriaWithoutEmpty = Object.keys(filteredCriteria).reduce((acc, key) => {
      if (filteredCriteria[key] !== null && filteredCriteria[key] !== "") {
        acc[key] = filteredCriteria[key];
      }
      return acc;
    }, {});
    localStorage.removeItem(`reportFilter_${reportId}`);
    setFilterCriteria({ ...filteredCriteriaWithoutEmpty });
    localStorage.setItem(`reportFilter_${reportId}`, JSON.stringify(filteredCriteriaWithoutEmpty));
    // console.log("filterCriteria", filteredCriteriaWithoutEmpty);
    handleOnClickPreview(filteredCriteriaWithoutEmpty);
  };

  return (
    <React.Fragment>
      <Helmet title={reportTitle} />

      <Container maxWidth="lg">
        {!!isLoading && <LinearProgress />}
        {!isLoading && !autoRun && (
          <AMFilter
            reportId={reportId}
            title={reportTitle}
            toolTip={reportToolTip}
            controls={filterControls}
            initialCriteria={filterCriteria}
            onApply={handleApplyFilter}
            applyTitle="Preview Report"
            expanded
          />
        )}
        <Grid container>
          <Dialog fullScreen open={viewPDF}>
            <Box height="100%" display="flex" flexDirection="column">
              {/* <Box bgcolor="common.white" p={2}> */}
              <Box p={2}>
                <ButtonGroup variant="contained" color="primary">
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => {
                      setViewPDF(false);
                      try {
                        onCloseViewer(true);
                      } catch (error) {}
                    }}
                  >
                    <NavigateBeforeIcon />
                    Back
                    {/* {getMessage("back")} */}
                  </Button>
                </ButtonGroup>
              </Box>
              <Box flexGrow={1}>
                {reportPath && (
                  <StReportViewer
                    key={stReportViewerKey}
                    reportPath={reportPath}
                    reportDataSet={reportDataSet}
                    filterCriteria={filterCriteria}
                    reportTitle={reportTitle}
                    menuItemCode={menuItemCode}
                  />
                )}

                {isLoading && <LinearProgress />}
              </Box>
            </Box>
          </Dialog>
        </Grid>
      </Container>
    </React.Fragment>
  );
}

export default ReportViewer;
